import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ReexamapiService } from '../../../api/reexamapi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from "@angular/cdk/collections";
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-reexam',
  templateUrl: './reexam.component.html',
  styleUrls: ['./reexam.component.css']
})
export class ReexamComponent implements OnInit {

  @ViewChild('t1Sort') t1Sort!: MatSort;
  @ViewChild('t1Paginator') t1Paginator!: MatPaginator;

  displayedColumns_view = ['OrderID','Amount','Date','CCAvenueRefNumber','PaymentType','CardName'];
  SRC_SELECTED_VIEW: any[] = [];
  DATA_SELECTED_VIEW = Object.assign(this.SRC_SELECTED_VIEW);
  dataSource_view = new MatTableDataSource<any>(this.DATA_SELECTED_VIEW);
  selected_view = new SelectionModel<any>(true, []);
  public int_index_edit_view: any;
  public query: string = '';
  public page: number = 1;
  public offset: number = 5;
  public pageEvent: any;
  totallengthData: any = 1;


  form1: boolean = true;
  public bool_pri_result: boolean = false;
  public bool_table:boolean = false;
  bdnuForm: any;
  submitted = false;
 
  public numberStud: any;



  public state: any;
  public district: any;
  public iticode: any;
  public trade: any;

  public pri_genrateid: any;
  public ccrefnoStatus: any;
  public var_placeholder = " Enter Order ID P16_PU09001617-1617099122"
  public enter_date: any;

  onChangeState(data: any) {
    //console.log(data.target.value);
    this.bdnuForm.get('district').reset();
    this.bdnuForm.get('iticode').reset();
    // this.bdnuForm.get('trade').reset();

    var myargs = {
      stateName: data.target.value
    }
    this.reapi.enterState(myargs).subscribe((result: any) => {
      //console.log(JSON.stringify(result));
      this.district = result;
    });
  }


  onChangeDistrict(data: any) {
    this.bdnuForm.get('iticode').reset();
    // this.bdnuForm.get('trade').reset();
    var myargs = {
      districtName: data.target.value
    }
    this.reapi.enterIticode(myargs).subscribe((result: any) => {
      console.log(JSON.stringify(result));
      this.iticode = result;

      this.bool_iti_select = true;
      this.bool_iti_text = false;

    });
  }

 
  public bool_bdnuForm = true;



  get f() {
    return this.bdnuForm.controls;
  }

  onSubmit() {
    //alert(d.getDate() + "/" + month + "/" + d.getFullYear())
    //alert("test: " + this.ccrefnoStatus)
    this.submitted = true;

    // stop here if form is invalid
    if (this.bdnuForm.invalid) {
      return;
    }

    this.reapi
      .insertbdnuForm(this.bdnuForm.value)
      .subscribe((result: any) => {
        console.log("bdnu: " + JSON.stringify(result));
        this.pri_genrateid = result.refid;
        this.form1 = false;
        this.bool_pri_result = true;
        window.scroll(0, 0);

      });
  }








  constructor(private formBuilder: FormBuilder, private reapi: ReexamapiService, private router: Router) { 

   }


  ngOnInit(): void {
    const d = new Date();
    var month = d.getMonth() + 1;

    this.enter_date = d.getDate() + "/" + month + "/" + d.getFullYear();


    this.reapi.liststate().subscribe((data: any) => {
      this.state = data;
      //console.log(data);
    });


    this.bdnuForm = this.formBuilder.group({
      state: ['', Validators.required],
      district: ['', Validators.required],
      iticode: ['', Validators.required],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      mobileno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      ccrefno: ['', [Validators.required]],
      crtccrefno: ['', Validators.required],
      crtorderid: ['', Validators.required],
      date: ['', Validators.required],
      payamount: ['', Validators.required],
      studCount: ['', Validators.required],
      numberofstud: ['', Validators.required],
      qualification: this.formBuilder.array([]),
      descreption: ['', [Validators.maxLength(500)]],
      acceptTerms: [false, Validators.requiredTrue],
      enterDate: [this.enter_date],
      // bulkrollno: [''],
    });



  }

  dataLoader2() {

    this.reapi.listJcDescriptionTitle(this.query, this.page, this.offset).subscribe((result: any) => {
      console.log(JSON.stringify(result));
      this.dataSource_view = new MatTableDataSource(result);
      this.dataSource_view.paginator = this.t1Paginator;
      this.dataSource_view.sort = this.t1Sort;      //this.ngAfterViewInit();


      this.reapi.listJcDescriptionTitleCount(this.query, this.page, this.offset).subscribe((result: any) => {

        this.totallengthData = result[0]['count'];
      });


    });


  }

  
  pageChangedData(event: any) {
    this.page = parseInt(event.pageIndex) + 1;
    this.offset = parseInt(event.pageSize);
    // this.totallength = 5000;
    // this.dataLoader();
    console.log(this.page + " , " + this.offset)
    this.reapi.listJcDescriptionTitle(this.query, this.page, this.offset).subscribe((result: any) => {
      this.dataSource_view = new MatTableDataSource(result);

    })
  }

  newQuantity(): FormGroup {
    return this.formBuilder.group({
      // bukregno: ['',  [Validators.required, Validators.pattern("^(19|18)[0-9]{10}$")]],
      bukregno: ['', Validators.required],

    })
  }


  get qualification(): FormArray {
   // console.log(this.bdnuForm.get("qualification") as FormArray)
    return this.bdnuForm.get("qualification") as FormArray
  }

  get qualificationFormGroups() { return this.qualification.controls as FormGroup[]; }


  addQualification() {
    this.qualification.push(this.newQuantity());
  }

  removeQualification(i: number) {

    this.qualification.removeAt(i);
  }



  public date = new Date().getDate();
  public month = new Date().getMonth() + 1;
  public year = new Date().getFullYear();
  public currentDate = this.date + '-' + this.month + '-' + this.year;

  datePickerConfig = {
    format: 'DD-MM-YYYY',
    min: '01-12-2020',
    max: '31-03-2021'
    //max: this.currentDate,
  };

  datePickerConfigDir = {
    format: 'DD-MM-YYYY',
    
    //max: this.currentDate,
  };


  onReset() {
    this.submitted = false;
    this.bdnuForm.reset();
  }





  totAmount: number = 0;
  onKey(event: any) {
    console.log(event.target.value);

    this.qualification.clear()


    // for (var i = 0; i < event.target.value; i++) {
    //   this.qualification.push(this.newQuantity());
    // }

    this.totAmount = event.target.value * 376;
  }




  test(event: any) {
    console.log(event.target.value);

    for (var i = 0; i < event.target.value; i++) {
      this.qualification.push(this.newQuantity());
    }

    // this.totAmount = event.target.value * 376;
  }


  omit_number(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_email(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 45 || k == 46 || k == 64 || k == 95 || k == 32);
  }

  omit_text(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  omit_spl(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_all(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 127 && k <= 0));
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  public bool_add:boolean = false;
  public studCount:any = 0;
  public paydate = 0;
  public crtccrefno= 0;
  public crtorderid = 0;
  public totpayamount = 0;

  cc_check(event: any) {
  


      var value = event.target.value;
      var args = {
        ccref: value
      }

      var myargs = {
        refid: event.target.value,
        query: this.query,
        page: this.page,
        offset: this.offset,  
      }
      
   
      this.reapi.listJcDescriptionTitlePost(myargs).subscribe((result: any) => {
        this.dataSource_view = new MatTableDataSource(result);
        this.dataSource_view.paginator = this.t1Paginator;
        this.dataSource_view.sort = this.t1Sort;      //this.ngAfterViewInit();
  
        console.log(result);
        this.reapi.listJcDescriptionTitlePostCount(myargs).subscribe((result: any) => {
          this.totallengthData = result[0]['count'];
        })
      });

      this.reapi.checkccrefStatus(args).subscribe((data: any) => {
        
        if(data.status == 'add'){
          alert('Already ' + data.status);
          this.ccrefnoStatus = 'blank';
          this.bool_add = false;
          this.studCount = 0;
          this.paydate = 0;
          this.totpayamount = 0;
          this.bdnuForm.controls['ccrefno'].reset();

          this.bool_table = true;
        }
        else{
          this.reapi.ccrefStatus(args).subscribe((data: any) => {

            if(data.status == 'fail'){
              alert('Enter correct CC ref number / Order ID')
              this.ccrefnoStatus = 'blank';
              this.bool_add = false;
              this.studCount = 0;
              this.paydate = 0;
              this.totpayamount = 0;
              this.bdnuForm.controls['ccrefno'].reset();
              this.bool_table = false;
            }
            else{
              this.bool_add = true;
              let amount = data[0]['PayableAmount'];
              this.totpayamount = data[0]['PayableAmount'];
              let divi = amount / 376;          
              this.studCount = divi.toFixed();
              this.paydate = data[0]['Date'];         
              this.crtorderid =  data[0]['OrderID'];
              this.crtccrefno =  data[0]['CCAvenueRefNumber'];
              this.bool_table = true;
              // this.bdnuForm.controls.ccrefnostatus.setValue(this.ccrefnoStatus);
    
            }
    
          });
        }
      });



      








  }



  public bool_iti_select: boolean = true;
  public bool_iti_text: boolean = false;

  entry_iti(event:any){
    if(event.target.value == 'Enter ITI Code'){
      // alert("test")
      this.bool_iti_select = false;
      this.bool_iti_text = true;

      this.bdnuForm.controls['iticode'].reset();
      return;
    }
  }



}



